import { render } from "./worldPage.vue?vue&type=template&id=b8cf8774&scoped=true"
import script from "./worldPage.vue?vue&type=script&lang=js"
export * from "./worldPage.vue?vue&type=script&lang=js"

import "./worldPage.vue?vue&type=style&index=0&id=b8cf8774&scoped=true&lang=css"

import exportComponent from "/Users/iyongmin/Documents/twin-cosmos/jeju43-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8cf8774"]])

export default __exports__